import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import FounderPromo from '../components/FounderPromo';
import GameplaySlideshow from '../components/GameplaySlideshow';
import { useLang } from '../context/LanguageContext';

const HomePage = () => {
  const { t } = useLang();
  return (
    <>
      <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-[#0a0608]">
        {/* Subtle radial vignette for depth on the clean dark hero */}
        <div
          className="absolute inset-0"
          aria-hidden="true"
          style={{
            background:
              'radial-gradient(ellipse at 50% 35%, rgba(245,180,0,0.08) 0%, rgba(10,6,8,0) 55%)',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/85" />

        <div className="relative z-10 w-full max-w-[1200px] px-6 pt-24 pb-16 flex flex-col items-center text-center fade-up">
          <h1 className="font-display title-glow leading-[0.95] tracking-wide text-[clamp(3.5rem,9vw,8rem)] font-black">
            <span className="block">New</span>
            <span className="block">Realm</span>
            <span className="block text-[0.55em] font-bold tracking-[0.4em]">ONLINE</span>
          </h1>

          <p className="mt-10 max-w-2xl text-white/90 font-body text-base md:text-lg banner-shadow">
            {t('home.hero.tagline')}
          </p>

          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link
              to="/about"
              className="bg-[#f5b400] hover:bg-[#ffc630] text-black font-nav text-xs px-7 py-3 rounded-md transition-colors"
            >
              {t('home.hero.cta_enter')}
            </Link>
            <Link
              to="/store"
              className="border border-white/40 hover:border-[#f5b400] hover:text-[#f5b400] text-white font-nav text-xs px-7 py-3 rounded-md transition-colors"
            >
              {t('home.hero.cta_store')}
            </Link>
          </div>

          <Link
            to="/about"
            className="mt-12 inline-flex items-center gap-2 text-[#f5b400] font-nav text-xs hover:text-white transition-colors"
          >
            {t('home.hero.discover_more')}
            <ChevronDown size={18} className="animate-bounce" />
          </Link>
        </div>
      </section>

      <GameplaySlideshow />

      <FounderPromo />
    </>
  );
};

export default HomePage;
